
import {Navbar} from "./ravi/navbar";
import Form2 from "./Forms/Form2"
export const StartForm2 = ()=>{

	return (<>
	<Navbar/>
	<Form2/>
	</>)
}